(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("bMqAB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $017cbbb51c31cdc4$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $kqTTL = parcelRequire("kqTTL");

var $6hlLf = parcelRequire("6hlLf");

const $017cbbb51c31cdc4$var$AssociationContent = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("drHGq")));
const $017cbbb51c31cdc4$var$AssociationAccordion = ({ label: label, id: id, associationInfo: associationInfo, wayDescription: wayDescription })=>{
    const [isExpanded, setIsExpanded] = (0, $dTCkE.useState)(false);
    const contentDiv = (0, $dTCkE.useRef)(null);
    const [prevHeight, setPrevHeight] = (0, $dTCkE.useState)("0");
    const [height, setHeight] = (0, $dTCkE.useState)();
    const { accordionOption: accordionOption, setAccordionOption: setAccordionOption } = (0, $dTCkE.useContext)((0, $kqTTL.ObjectPageContext)); // this is to able to open specific specific accordion from elsewhere
    (0, $dTCkE.useEffect)(()=>{
        if (contentDiv.current) {
            let contentHeight = isExpanded ? `${contentDiv.current.scrollHeight}px` : "0px";
            setPrevHeight(contentHeight);
            setHeight(contentHeight);
        }
        if (isExpanded) setTimeout(()=>{
            setHeight("auto");
        }, 200); //this must be same as transition duration
        else {
            setHeight(prevHeight);
            setTimeout(()=>{
                setHeight("0px");
            }, 10);
        }
    }, [
        isExpanded
    ]);
    (0, $dTCkE.useEffect)(()=>{
        if (accordionOption === id) setIsExpanded(true);
    }, [
        accordionOption,
        id
    ]);
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        id: id,
        className: "accordion",
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsx)((0, $6hlLf.default), {
                isExpanded: isExpanded,
                setIsExpanded: setIsExpanded,
                setAccordionOption: setAccordionOption,
                label: label
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                ref: contentDiv,
                style: {
                    height: height
                },
                className: `overflow-hidden transition-height ease duration-200`,
                children: isExpanded && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                    fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {}),
                    children: /*#__PURE__*/ (0, $a9eYm.jsx)($017cbbb51c31cdc4$var$AssociationContent, {
                        associationInfo: associationInfo,
                        wayDescription: wayDescription
                    })
                })
            })
        ]
    });
};
var $017cbbb51c31cdc4$export$2e2bcd8739ae039 = $017cbbb51c31cdc4$var$AssociationAccordion;

});
parcelRegister("6hlLf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc1b4d56f89a3116$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");
const $cc1b4d56f89a3116$var$AccordionContent = ({ isExpanded: isExpanded, label: label, setIsExpanded: setIsExpanded, setAccordionOption: setAccordionOption })=>{
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        className: `flex justify-between items-center ${isExpanded ? "bg-blue200" : "bg-blue100"} hover:bg-blue200 px-3 lg:px-5 py-3 rounded-md transition-all cursor-pointer`,
        onClick: ()=>{
            setIsExpanded(!isExpanded);
            setAccordionOption("");
        },
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsx)("h3", {
                className: `text-blue700 font-icb text-lg lg:text-xl mb-0`,
                children: label
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                width: "20",
                height: "20",
                src: "/Images/Icons/Arrows/arrow-down-blue700.svg",
                className: `h-5 w-auto transition ease duration-200 ${isExpanded ? "rotate-180" : ""}`,
                alt: "pil",
                loading: "lazy"
            })
        ]
    });
};
var $cc1b4d56f89a3116$export$2e2bcd8739ae039 = $cc1b4d56f89a3116$var$AccordionContent;

});

parcelRegister("drHGq", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("kFjMk")).then(()=>parcelRequire("grte1"));

});


})();
//# sourceMappingURL=AssociationAccordion.0c045d5b.js.map
